import React from 'react';

import DirectoryPage from '../../js/pages/DirectoryPage';
import {getTags} from '../../../server/services/tags';

export default function Page({companies}) {
  return <DirectoryPage title="Companies" companies={companies} />;
}

export async function getStaticProps() {
  const {products: {questions: {company}}} = await getTags();

  return {
    props: {companies: JSON.parse(JSON.stringify(company))}, // serialize to make Next happy
    revalidate: 3600,
  };
}
